module.exports = __webpack_public_path__ + "img/mb-step-3.d2b18002.png";